<template>
  <div class="q-pa-xs">
    <div class="row col-12" style="border: 1px solid black">
      <div style="width: 18%" class="q-pa-lg border-right">
        <div class="row col-12 justify-center items-center">
          <q-img
            v-if="$store.state.autenticacao.logo.logoImpressao"
            :src="$store.state.autenticacao.logo.logoImpressao"
          />
          <q-img v-else src="../../../../assets/MULTPEX_LOGO.png" />
        </div>
      </div>
      <div style="width: 45%" class="q-pa-sm border-right">
        <span class="text-h6">Nome Empresa</span>
        <div class="row col-12 justify-between q-mt-sm texto-conteudo">
          <span>Rua Teste, Numero - Bairro</span>
          <span>CNPJ: <b>03.422.293/0001-93</b></span>
        </div>
        <div class="row col-12 justify-between texto-conteudo">
          <span>São Paulo - SP - CEP: 04.551-000 - FONE: (11) 3047-</span>
          <span>IE: <b>128.593.586.115</b></span>
        </div>
      </div>
      <div style="width: 17%" class="q-pa-sm border-right">
        <span class="row col-12 justify-center">
          <span class="text-subtitle1">Datas</span>
          <span class="row col-12 justify-center texto-conteudo"
            >Impressão: {{ dados.dataAtual }}</span
          >
          <span class="row col-12 justify-center texto-conteudo"
            >Criação:
            {{
              detalhesTransferencia.createdAt?.date
                ?.split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span
          >
        </span>
      </div>
      <div style="width: 20%" class="q-pa-sm">
        <span class="text-subtitle1 row col-12 justify-center">
          <span>Num. Transferência</span>
          <span class="text-h4 row col-12 justify-center"
            ><b>{{ transferenciaId }}</b></span
          >
        </span>
      </div>
    </div>
    <div class="row col-12 q-mt-lg" style="border: 1px solid black">
      <div style="width: 10%" class="border-right">
        <div
          class="row col-12 justify-center items-center"
          style="height: 100%"
        >
          <span class="texto-titulo"><b>ORIGEM</b></span>
        </div>
      </div>
      <div style="width: 15%" class="border-right q-pa-xs">
        <div class="row col-12">
          <span class="row col-12 texto-conteudo">Canteiro</span>
          <span class="row col-12 q-mt-sm">{{
            detalhesTransferencia.depositoSaida?.descricao
          }}</span>
        </div>
      </div>
      <div style="width: 21%" class="border-right q-pa-xs">
        <div class="row col-12">
          <span class="row col-12 texto-conteudo">Endereço</span>
          <span class="row col-12 q-mt-sm">{{
            detalhesTransferencia.depositoSaida?.endereco
          }}</span>
        </div>
      </div>
      <div style="width: 15%" class="border-right q-pa-xs">
        <div class="row col-12">
          <span class="row col-12 texto-conteudo">Bairro</span>
          <span class="row col-12 q-mt-sm">{{
            detalhesTransferencia.depositoSaida?.bairro
          }}</span>
        </div>
      </div>
      <div style="width: 12%" class="border-right q-pa-xs">
        <div class="row col-12">
          <span class="row col-12 texto-conteudo">CEP</span>
          <span class="row col-12 q-mt-sm">{{
            detalhesTransferencia.depositoSaida?.cep
          }}</span>
        </div>
      </div>
      <div style="width: 15%" class="border-right q-pa-xs">
        <div class="row col-12">
          <span class="row col-12 texto-conteudo">Municipio</span>
          <span class="row col-12 q-mt-sm">{{
            detalhesTransferencia.depositoSaida?.municipio
          }}</span>
        </div>
      </div>
      <div style="width: 12%" class="q-pa-xs">
        <div class="row col-12">
          <span class="row col-12 texto-conteudo">UF</span>
          <span class="row col-12 q-mt-sm">{{
            detalhesTransferencia.depositoSaida?.estado
          }}</span>
        </div>
      </div>
    </div>
    <div class="row col-12 q-mt-lg" style="border: 1px solid black">
      <div style="width: 10%" class="border-right">
        <div
          class="row col-12 justify-center items-center"
          style="height: 100%"
        >
          <span class="texto-titulo"><b>DESTINO</b></span>
        </div>
      </div>
      <div style="width: 15%" class="border-right q-pa-xs">
        <div class="row col-12">
          <span class="row col-12 texto-conteudo">Canteiro</span>
          <span class="row col-12 q-mt-sm">{{
            detalhesTransferencia.depositoEntrada?.descricao
          }}</span>
        </div>
      </div>
      <div style="width: 21%" class="border-right q-pa-xs">
        <div class="row col-12">
          <span class="row col-12 texto-conteudo">Endereço</span>
          <span class="row col-12 q-mt-sm">{{
            detalhesTransferencia.depositoEntrada?.endereco
          }}</span>
        </div>
      </div>
      <div style="width: 15%" class="border-right q-pa-xs">
        <div class="row col-12">
          <span class="row col-12 texto-conteudo">Bairro</span>
          <span class="row col-12 q-mt-sm">{{
            detalhesTransferencia.depositoEntrada?.bairro
          }}</span>
        </div>
      </div>
      <div style="width: 12%" class="border-right q-pa-xs">
        <div class="row col-12">
          <span class="row col-12 texto-conteudo">CEP</span>
          <span class="row col-12 q-mt-sm">{{
            detalhesTransferencia.depositoEntrada?.cep
          }}</span>
        </div>
      </div>
      <div style="width: 15%" class="border-right q-pa-xs">
        <div class="row col-12">
          <span class="row col-12 texto-conteudo">Municipio</span>
          <span class="row col-12 q-mt-sm">{{
            detalhesTransferencia.depositoEntrada?.municipio
          }}</span>
        </div>
      </div>
      <div style="width: 12%" class="q-pa-xs">
        <div class="row col-12">
          <span class="row col-12 texto-conteudo">UF</span>
          <span class="row col-12 q-mt-sm">{{
            detalhesTransferencia.depositoEntrada?.estado
          }}</span>
        </div>
      </div>
    </div>
    <div class="q-mt-md">
      <div class="q-px-md">
        <div class="row col-12" style="border: 1px solid gray"></div>
        <div class="row col-12 text-h6 q-my-sm">Produtos Selecionados</div>
        <div class="row col-12" style="border: 1px solid gray"></div>
      </div>
      <q-table
        :columns="columns"
        :rows="produtosTransferencia"
        color="primary"
        dense
        table-header-class="bg-white text-weight-bolder"
        flat
        hide-bottom
        row-key="index"
        :rows-per-page-options="[0]"
      >
        <template v-slot:body-cell-index="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.index + 1 }}
          </q-td>
        </template>
        <template v-slot:body-cell-codigo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.codigo_produto }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.nome_produto }}
          </q-td>
        </template>
        <template v-slot:body-cell-unidadeMedida="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.origem_unidade_medida }}
          </q-td>
        </template>
        <template v-slot:body-cell-quantidadeTransferencia="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ parseFloat(props.row.quantidade_saida).toFixed(2) }}
          </q-td>
        </template>
      </q-table>
    </div>
    <div class="q-mt-md q-ml-sm">TRANSPORTE / VOLUMES TRANSPORTADOS</div>
    <div class="row col-12" style="border: 1px solid black">
      <div style="width: 24%" class="border-right">
        <span class="row col-12 q-px-xs q-my-xs" style="font-size: 11px"
          >Nome Colaborador</span
        >
        <input class="" style="height: 20px; width: 100%" />
      </div>
      <div style="width: 24%" class="border-right">
        <span class="row col-12 q-px-xs q-my-xs" style="font-size: 11px"
          >Matricula ou nome da empresa Contratada</span
        >
        <input class="" style="height: 20px; width: 100%" />
      </div>
      <div style="width: 16%" class="border-right">
        <span class="row col-12 q-px-xs q-my-xs" style="font-size: 11px"
          >Placa do Veiculo
        </span>
        <input class="" style="height: 20px; width: 100%" />
      </div>
      <div style="width: 16%" class="border-right">
        <span class="row col-12 q-px-xs q-my-xs" style="font-size: 11px"
          >Quantidade
        </span>
        <input class="" style="height: 20px; width: 100%" />
      </div>
      <div style="width: 20%">
        <span class="row col-12 q-px-xs q-my-xs" style="font-size: 11px"
          >Espécie em Volume
        </span>
        <input class="" style="height: 20px; width: 100%" />
      </div>
    </div>
    <div class="row col-12 q-mt-md" style="border: 1px solid black">
      <div style="width: 50%" class="border-right">
        <span class="row col-12 q-ml-sm">DADOS ORIGEM / SEPARADO POR: </span>
        <div class="row col-12 border-top">
          <div style="width: 34%" class="border-right">
            <span class="row col-12 q-px-xs q-my-xs" style="font-size: 11px"
              >Nome:</span
            >
            <div style="height: 20px; width: 100%" class="border-top">
              {{ detalhesTransferencia?.operador_separacao?.nome }}
            </div>
          </div>
          <div style="width: 33%" class="border-right">
            <span class="row col-12 q-px-xs q-my-xs" style="font-size: 11px"
              >Matricula:</span
            >
            <div style="height: 20px; width: 100%" class="border-top">
              {{ detalhesTransferencia?.operador_separacao?.sap }}
            </div>
          </div>
          <div style="width: 33%">
            <span class="row col-12 q-px-xs q-my-xs" style="font-size: 11px"
              >Assinatura:</span
            >
            <div style="height: 20px; width: 100%" class="border-top"></div>
          </div>
        </div>
      </div>
      <div style="width: 50%">
        <span class="row col-12 q-ml-sm">RECEBEDOR DO MATERIAL: </span>
        <div class="row col-12 border-top">
          <div style="width: 34%" class="border-right">
            <span class="row col-12 q-px-xs q-my-xs" style="font-size: 11px"
              >Nome:</span
            >
            <div style="height: 20px; width: 100%" class="border-top">
              {{ detalhesTransferencia?.operador_separador?.nome }}
            </div>
          </div>
          <div style="width: 33%" class="border-right">
            <span class="row col-12 q-px-xs q-my-xs" style="font-size: 11px"
              >Matricula:</span
            >
            <div style="height: 20px; width: 100%" class="border-top">
              {{ detalhesTransferencia?.operador_separador?.sap }}
            </div>
          </div>
          <div style="width: 33%">
            <span class="row col-12 q-px-xs q-my-xs" style="font-size: 11px"
              >Assinatura:</span
            >
            <div style="height: 20px; width: 100%" class="border-top"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="q-mt-md q-ml-sm">DADOS ADICIONAIS</div>
    <div class="row col-12" style="border: 1px solid black">
      <span class="row col-12 q-ml-xs q-mt-xs" style="font-size: 11px">
        Informações Complementares
      </span>
      <q-input
        :disable="detalhesTransferencia.status?.valor != 'criado'"
        v-model="dadosEditaveis.descricao"
        class="col-12"
        dense
        outlined
        type="textarea"
        autogrow
        @blur="alterarDescricao()"
      />
    </div>
    <div
      class="row col-12 q-mt-md"
      style="border: 1px solid black; font-size: 11px"
    >
      <div class="col" style="display: flex">
        <div
          style="
            width: 67%;
            display: flex;
            flex-direction: column;
            border-right: 1px solid black;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              border-bottom: 1px solid black;
              padding: 5px;
            "
          >
            <span style="flex: 1">USUÁRIO ENVIO</span>
            <span style="flex: 1">DATA: </span>
          </div>
          <div style="display: flex; flex: 1">
            <div style="flex: 1; border-right: 1px solid black">
              <span style="display: block; font-size: 11px; padding: 2px"
                >Nome:</span
              >
              <div
                style="height: 100%; border-top: 1px solid black; padding: 3px"
              >
                {{ detalhesTransferencia?.operador_manipulacao_envio?.nome }}
              </div>
            </div>
            <div style="flex: 1">
              <span style="display: block; font-size: 11px; padding: 2px"
                >Matrícula:</span
              >
              <div
                style="height: 100%; border-top: 1px solid black; padding: 3px"
              >
                {{ detalhesTransferencia?.operador_manipulacao_envio?.sap }}
              </div>
            </div>
          </div>
        </div>

        <div
          style="
            width: 33%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <span class="text-conteudo text-bold"
            ><span class="impressao"> ASSINATURA: </span>
            {{
              detalhesTransferencia?.operador_manipulacao_envio?.assinatura
                ?.authType == "nao_preenchido"
                ? ""
                : detalhesTransferencia?.operador_manipulacao_envio?.assinatura
                    ?.authType == "assinatura" ||
                  detalhesTransferencia?.operador_manipulacao_envio?.assinatura
                    ?.authType == "biometria"
                ? detalhesTransferencia?.operador_manipulacao_envio?.assinatura
                    ?.authType
                : null
            }}</span
          >
          <div style="flex: 1; width: 100%">
            <div
              v-if="
                detalhesTransferencia?.operador_manipulacao_envio?.assinatura
                  ?.authType == 'biometria' ||
                detalhesTransferencia?.operador_manipulacao_envio?.assinatura
                  ?.authType == 'assinatura'
              "
            >
              <q-img :src="imagens?.envio" />
            </div>
            <div class="text-conteudo" v-else>
              <span class="text-conteudo text-bold"
                >Assinado Eletronicamente</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="col" style="border-left: 1px solid black; display: flex">
        <div
          style="
            width: 67%;
            display: flex;
            flex-direction: column;
            border-right: 1px solid black;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              border-bottom: 1px solid black;
              padding: 5px;
            "
          >
            <span style="flex: 1">USUÁRIO RECEBIMENTO</span>
            <span style="flex: 1">DATA: </span>
          </div>
          <div style="display: flex; flex: 1">
            <div style="flex: 1; border-right: 1px solid black">
              <span style="display: block; font-size: 11px; padding: 2px"
                >Nome:</span
              >
              <div
                style="height: 100%; border-top: 1px solid black; padding: 3px"
              >
                {{
                  detalhesTransferencia?.operador_manipulacao_recebimento?.nome
                }}
              </div>
            </div>
            <div style="flex: 1">
              <span style="display: block; font-size: 11px; padding: 2px"
                >Matrícula:</span
              >
              <div
                style="height: 100%; border-top: 1px solid black; padding: 3px"
              >
                {{
                  detalhesTransferencia?.operador_manipulacao_recebimento?.sap
                }}
              </div>
            </div>
          </div>
        </div>

        <div
          style="
            width: 33%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <span class="text-conteudo text-bold"
            ><span class="impressao"> ASSINATURA: </span>
            {{
              detalhesTransferencia?.operador_manipulacao_recebimento
                ?.assinatura?.authType == "nao_preenchido"
                ? ""
                : detalhesTransferencia?.operador_manipulacao_recebimento
                    ?.assinatura?.authType == "assinatura" ||
                  detalhesTransferencia?.operador_manipulacao_recebimento
                    ?.assinatura?.authType == "biometria"
                ? detalhesTransferencia?.operador_manipulacao_recebimento
                    ?.assinatura?.authType
                : null
            }}</span
          >
          <div style="flex: 1; width: 100%">
            <div
              v-if="
                detalhesTransferencia?.operador_manipulacao_recebimento
                  ?.assinatura?.authType == 'biometria' ||
                detalhesTransferencia?.operador_manipulacao_recebimento
                  ?.assinatura?.authType == 'assinatura'
              "
            >
              <q-img :src="imagens?.recebimento" />
            </div>
            <div v-else>
              <span class="text-conteudo text-bold"
                >Assinado Eletronicamente</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

const columns = [
  {
    name: "index",
    label: "Item",
    align: "left",
    field: "index",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "unidadeMedida",
    label: "Unid. Medida",
    align: "left",
  },
  {
    name: "quantidadeTransferencia",
    label: "Quantidade na Transferência",
    align: "left",
  },
];
export default {
  setup() {
    const route = useRoute();
    const store = useStore();

    const transferenciaId = route.params.transferenciaId;
    const detalhesTransferencia = ref([]);
    const produtosTransferencia = ref([]);
    const dados = ref({
      dataAtual: new Date().toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }),
    });
    const dadosEditaveis = ref("");
    const imagens = ref({
      envio: null,
      recebimento: null,
    });

    const receberDetalhesTransferencia = async () => {
      try {
        store.dispatch("pdt/hiddenHeader", false);
        const response = await store.dispatch(
          "transferencia/detalharTransferencia",
          {
            id: transferenciaId,
          }
        );
        detalhesTransferencia.value = response.data.result;
        dadosEditaveis.value = { ...detalhesTransferencia.value };

        if (
          detalhesTransferencia.value?.operador_manipulacao_envio?.assinatura
            ?.authType == "assinatura" ||
          detalhesTransferencia.value?.operador_manipulacao_envio?.assinatura
            ?.authType == "biometria"
        ) {
          imagens.value.envio =
            detalhesTransferencia.value?.operador_manipulacao_envio?.assinatura?.authContent;
        }

        if (
          detalhesTransferencia.value?.operador_manipulacao_recebimento
            ?.assinatura?.authType == "assinatura" ||
          detalhesTransferencia.value?.operador_manipulacao_recebimento
            ?.assinatura?.authType == "biometria"
        ) {
          imagens.value.recebimento =
            detalhesTransferencia.value?.operador_manipulacao_recebimento?.assinatura?.authContent;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const listagemDetalhada = async () => {
      try {
        const response = await store.dispatch(
          "transferencia/listagemDetalhada",
          {
            id: transferenciaId,
          }
        );
        produtosTransferencia.value = response.data.result.data;
        produtosTransferencia.value.forEach((row, index) => {
          row.index = index;
        });
      } catch (error) {
        console.log(error);
      }
    };

    const assinarImagem = async (fileUrl) => {
      try {
        const response = await store.dispatch("notificacao/assinarRelatorio", {
          fileUrl: fileUrl,
        });
        return response.data.resultado.dados;
      } catch (error) {
        console.log(error);
      }
    };

    const alterarDescricao = async () => {
      try {
        await store.dispatch("transferencia/alterarDescricao", {
          id: transferenciaId,
          descricao: dadosEditaveis.value.descricao,
        });
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(receberDetalhesTransferencia);
    onMounted(listagemDetalhada);

    return {
      columns,
      transferenciaId,
      detalhesTransferencia,
      receberDetalhesTransferencia,
      dados,
      produtosTransferencia,
      dadosEditaveis,
      alterarDescricao,
      imagens,
      assinarImagem,
    };
  },
};
</script>

<style scoped>
.border-right {
  border-right: 1px solid black;
}
.border-left {
  border-left: 1px solid black;
}
.texto-titulo {
  font-size: 18px;
}
.border-top {
  border-top: 1px solid black;
}
@media print {
  .texto-titulo {
    font-size: 14px;
  }
  .texto-conteudo {
    font-size: 12px;
  }
  .impressao {
    display: none;
  }
}
</style>
